import sessionStore from 'store/storages/sessionStorage'

import { getCurrentUrl, redirectToUrl } from 'Shared/utils/url/helpers'

import { REDIRECT_URI_DATA, USER_TYPE_LABELS_DATA } from 'Core/constants/auth'
import { getEnv } from 'Core/env'
import { UserTypeLabel } from 'Core/interfaces'

export const redirectChecking = (userType?: string, signInRedirect?: () => void) => {
	const isBackToAdmin = window.location.search.includes('backToAdminFromExternalUser=true')

	if (isBackToAdmin) {
		signInRedirect?.()
		return
	}

	if (!userType) {
		return
	}

	const redirectUri: string | undefined = REDIRECT_URI_DATA[USER_TYPE_LABELS_DATA[userType]] as
		| string
		| undefined

	if (!redirectUri) {
		return
	}

	redirectToUrl(redirectUri)
}

export const backToAdminRedirect = () =>
	redirectToUrl(`${REDIRECT_URI_DATA[UserTypeLabel.internal]}?backToAdminFromExternalUser=true`)

export const goBackToAdmin = () => {
	sessionStore.clearAll()
	backToAdminRedirect()
}

export const updatePasswordRedirect = (userName: string) => {
	const env = getEnv()
	const returnUrl = encodeURIComponent(getCurrentUrl())
	const url = `${env.REACT_APP_OIDC_AUTHORITY}/Account/ChangePassword?ReturnUrl=${returnUrl}&UserName=${userName}`

	redirectToUrl(url)
}

export const handleLogout = ({
	isImpersonatedMode,
	signOutRedirect
}: {
	signOutRedirect: () => void
	isImpersonatedMode?: boolean
}) => {
	if (isImpersonatedMode) {
		goBackToAdmin()
		return
	}

	signOutRedirect()
}
